module.exports = __webpack_public_path__ + "static/media/204A-1404A.6c3e6795.png";